module.exports = __webpack_public_path__ + "static/media/wowza-logo.a364fca4.png";